import React from 'react';
import { Grid, Box, Card, CardContent, Skeleton, Typography, List, ListItem, ListItemText } from '@mui/material';

const ProfileSkeleton = () => {
    return (
        <div className="content" style={{ padding: 0 }}>
            <Box
                sx={{
                    backgroundColor: '#EEF5FF',
                    height: '100%',
                    overflow: 'hidden',
                    borderRadius: '8px',
                    border: 1,
                    borderColor: 'divider',
                }}
            >
                <Grid container spacing={2} sx={{ overflow: 'auto', height: '92vh', p: 2 }}>
                    <Grid item xl={8} md={8}>
                        <Card
                            sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '42.5vh' }}
                        >
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <Skeleton variant="rectangular" width="100%" height={200} sx={{ my: 2 }} />
                                <Skeleton variant="text" width="60%" />
                                <Skeleton variant="text" width="80%" />
                                <Skeleton variant="text" width="50%" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xl={4} md={4}>
                        <Card
                            sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '22.5vh' }}
                        >
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <Skeleton variant="text" width="90%" height={20} sx={{ mt: 2 }} />
                                <Skeleton variant="text" width="90%" height={20} sx={{ mt: 1 }} />
                                <Skeleton variant="text" width="90%" height={20} sx={{ mt: 1 }} />
                            </CardContent>
                        </Card>
                        <Card
                            sx={{
                                mt: 2,
                                borderRadius: '8px',
                                boxShadow: 'none',
                                border: 1,
                                borderColor: 'divider',
                                height: '21vh',
                            }}
                        >
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <List sx={{ overflow: 'auto', height: '14vh' }}>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <ListItem key={index} sx={{ py: 0 }}>
                                            <ListItemText
                                                primary={<Skeleton variant="text" width="90%" />}
                                                secondary={<Skeleton variant="text" width="60%" />}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xl={12} md={12}>
                        <Card sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '37vh' }}>
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <List sx={{ overflow: 'auto', height: '27vh' }}>
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <ListItem key={index} sx={{ py: 0 }}>
                                            <ListItemText
                                                primary={<Skeleton variant="text" width="90%" />}
                                                secondary={<Skeleton variant="text" width="60%" />}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xl={12} md={12}>
                        <Card sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '35vh' }}>
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <List sx={{ overflow: 'auto', height: '30vh' }}>
                                    {Array.from({ length: 3 }).map((_, index) => (
                                        <ListItem key={index} sx={{ py: 0 }}>
                                            <Skeleton variant="rectangular" width="100%" height={50} sx={{ my: 2 }} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xl={12} md={12}>
                        <Card sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '27vh' }}>
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <List sx={{ overflow: 'auto', height: '25vh' }}>
                                    {Array.from({ length: 2 }).map((_, index) => (
                                        <ListItem key={index} sx={{ py: 0 }}>
                                            <Skeleton variant="rectangular" width="100%" height={50} sx={{ my: 2 }} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xl={12} md={12}>
                        <Card sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '30vh' }}>
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <List sx={{ overflow: 'auto', height: '25vh' }}>
                                    {Array.from({ length: 3 }).map((_, index) => (
                                        <ListItem key={index} sx={{ py: 0 }}>
                                            <ListItemText
                                                primary={<Skeleton variant="text" width="90%" />}
                                                secondary={<Skeleton variant="text" width="60%" />}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xl={12} md={12}>
                        <Card sx={{ borderRadius: '8px', boxShadow: 'none', border: 1, borderColor: 'divider', maxHeight: '35vh' }}>
                            <CardContent>
                                <Skeleton variant="text" width="30%" height={30} />
                                <List sx={{ overflow: 'auto', height: '27vh' }}>
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <ListItem key={index} sx={{ py: 0 }}>
                                            <ListItemText
                                                primary={<Skeleton variant="text" width="90%" />}
                                                secondary={<Skeleton variant="text" width="60%" />}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};

export default ProfileSkeleton;
